import apiRequestPopinfo from './index'

/**
 * CLSアプリではFANSHIPのAPIを使用する際のデバイスタイプはi(iOS)固定
 * ref.https://iridge.slack.com/archives/GGDLUUB27/p1603427375339700
 */
const COUPON_API_DTYPE_IOS = 'i'

export default {
  path: '/api/v1/users/' + process.env.VUE_APP_POPINFO_SID,
  async post (popinfoId, couponUuid) {
    console.log('*** call API popinfoCouponUse ***')
    console.log(`${this.path}/${COUPON_API_DTYPE_IOS}/${popinfoId}/coupons/${couponUuid}/use/`)
    return apiRequestPopinfo.post(`${this.path}/${COUPON_API_DTYPE_IOS}/${popinfoId}/coupons/${couponUuid}/use/`)
  }
}
